export default __webpack_public_path__ + "static/media/tv.c022790c.png";